import _toConsumableArray from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.array.find-index";
import _regenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getToken } from '@/utils/auth';
import { fileUpload, scanUploadQrcode as _scanUploadQrcode, scanUploadGet as _scanUploadGet, onlineUpload, scanUploadSave } from '@/api/setting';
import QRCode from 'qrcodejs2';
import compressImg from '@/utils/compressImg.js';
import SettingMer from '@/libs/settingMer';
export default {
  name: '',
  props: {
    categoryList: {
      default: function _default() {
        return [];
      }
    },
    categoryId: {
      default: ''
    },
    isPage: {
      default: false
    },
    isIframe: {
      default: false
    },
    limit: {
      type: Number,
      default: 9
    }
  },
  data: function data() {
    return {
      webImgUrl: '',
      uploadModal: false,
      fileUrl: SettingMer.https + "/upload/image/0/file",
      myHeaders: {
        'X-Token': getToken()
      },
      uploadData: {},
      props: {
        checkStrictly: true,
        emitPath: false,
        label: 'attachment_category_name',
        value: 'attachment_category_id'
      },
      disabled: false,
      ruleForm: {
        type: 0,
        region: 0,
        imgList: []
      },
      rules: {
        type: [{
          required: true,
          message: '请选择活动资源',
          trigger: 'change'
        }]
      },
      qrcode: '',
      scanToken: '',
      pageSize: 50,
      loading: false,
      time: undefined
    };
  },
  watch: {
    uploadModal: {
      handler: function handler(newVal) {
        if (newVal) this.ruleForm.region = this.categoryId;
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.time);
    this.time = undefined;
  },
  methods: {
    radioChange: function radioChange(type) {
      var _this = this;
      this.ruleForm.type = type;
      this.ruleForm.imgList = [];
      clearInterval(this.time);
      this.time = undefined;
      if (type === 2) {
        this.scanUploadQrcode();
        this.time = setInterval(function (e) {
          _this.scanUploadGet();
        }, 2000);
      }
    },
    scanUploadQrcode: function scanUploadQrcode() {
      var _this2 = this;
      _scanUploadQrcode(this.ruleForm.region).then(function (res) {
        _this2.creatQrCode(res.data.url);
        _this2.scanToken = res.data.url;
      });
    },
    scanUploadGet: function scanUploadGet() {
      var _this3 = this;
      var token = this.scanToken.split('token=')[1];
      _scanUploadGet(token).then(function (res) {
        _this3.ruleForm.imgList = res.data;
      });
    },
    getImg: function getImg() {
      if (!this.webImgUrl) {
        this.$message.error('请先输入图片地址');
        return;
      }
      this.ruleForm.imgList.push({
        url: this.webImgUrl
      });
    },
    submitUpload: function () {
      var _submitUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this4 = this;
        var i, file, urls, token, attId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.ruleForm.imgList <= 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this.$message.error('请上传图片'));
            case 1:
              if (!(this.ruleForm.type === 0)) {
                _context.n = 7;
                break;
              }
              this.uploadData = {
                pid: this.ruleForm.region
              };
              if (!this.ruleForm.imgList.length) {
                _context.n = 6;
                break;
              }
              if (!this.loading) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              this.loading = true;
              i = 0;
            case 3:
              if (!(i < this.ruleForm.imgList.length)) {
                _context.n = 6;
                break;
              }
              file = this.ruleForm.imgList[i].raw;
              _context.n = 4;
              return this.uploadItem(file);
            case 4:
              if (i === this.ruleForm.imgList.length - 1) {
                this.$message.success('上传成功');
                this.$emit('uploadSuccess');
                this.uploadModal = false;
                this.loading = false;
                this.initData();
              }
            case 5:
              i++;
              _context.n = 3;
              break;
            case 6:
              _context.n = 11;
              break;
            case 7:
              if (!(this.ruleForm.type === 1)) {
                _context.n = 10;
                break;
              }
              urls = this.ruleForm.imgList.map(function (e) {
                return e.url;
              });
              if (!urls.length) {
                _context.n = 9;
                break;
              }
              if (!this.loading) {
                _context.n = 8;
                break;
              }
              return _context.a(2);
            case 8:
              this.loading = true;
              onlineUpload({
                id: this.ruleForm.region,
                images: urls
              }).then(function (res) {
                _this4.$message.success('上传成功');
                _this4.$emit('uploadSuccess');
                _this4.uploadModal = false;
                _this4.loading = false;
                _this4.initData();
              }).catch(function (err) {
                _this4.loading = false;
                _this4.$message.error(err.message);
              });
            case 9:
              _context.n = 11;
              break;
            case 10:
              if (this.ruleForm.type === 2) {
                token = this.scanToken.split('token=')[1];
                attId = this.ruleForm.imgList.map(function (e) {
                  return e.attachment_id;
                });
                scanUploadSave(token, {
                  pid: this.ruleForm.region,
                  ids: attId
                }).then(function (res) {
                  _this4.$message.success(res.message);
                  _this4.$emit('uploadSuccess');
                  _this4.uploadModal = false;
                  _this4.initData();
                });
              }
            case 11:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function submitUpload() {
        return _submitUpload.apply(this, arguments);
      }
      return submitUpload;
    }(),
    uploadItem: function uploadItem(file) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        var formData = new FormData();
        formData.append('file', file);
        fileUpload(_this5.ruleForm.region, formData).then(function (res) {
          if (res.code === 200) {
            resolve();
          } else {
            _this5.loading = false;
            _this5.$message({
              message: '上传失败',
              type: 'error',
              duration: 1000
            });
          }
        }).catch(function (err) {
          _this5.loading = false;
          _this5.$message.error(err.message);
        });
      });
    },
    beforeUpload: function beforeUpload(file) {},
    creatQrCode: function creatQrCode(url) {
      this.$refs.qrCodeUrl.innerHTML = '';
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url,
        // 需要转换为二维码的内容
        width: 160,
        height: 160,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    handleWebRemove: function handleWebRemove(file) {
      var index = this.ruleForm.imgList.findIndex(function (e) {
        return e.url === file.url;
      });
      this.ruleForm.imgList.splice(index, 1);
    },
    handleRemove: function handleRemove(index) {
      this.ruleForm.imgList.splice(index, 1);
    },
    fileChange: function () {
      var _fileChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file, fileList) {
        var _this6 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'].indexOf(file.raw.type) === -1)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, this.$message.error('请上传正确的文件格式！'));
            case 1:
              if (!(file.size >= 2097152)) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.comImg(file.raw).then(function (res) {
                fileList.map(function (e) {
                  // if (e.uid === file.uid) {
                  //   e.raw = res;
                  // }
                });
                _this6.ruleForm.imgList = fileList;
              });
            case 2:
              _context2.n = 4;
              break;
            case 3:
              this.ruleForm.imgList = fileList;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function fileChange(_x, _x2) {
        return _fileChange.apply(this, arguments);
      }
      return fileChange;
    }(),
    comImg: function comImg(file) {
      return new Promise(function (resolve, reject) {
        compressImg(file).then(function (res) {
          resolve(res);
        });
      });
    },
    handleChange: function handleChange(e) {
      this.fileUrl = SettingMer.https + "/upload/image/".concat(this.ruleForm.region, "/file");
      if (this.ruleForm.type === 2) this.scanUploadQrcode();
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      var newItems = _toConsumableArray(this.ruleForm.imgList);
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      this.ruleForm.imgList = newItems;
    },
    closed: function closed() {
      this.initData();
    },
    clear: function clear() {
      this.uploadModal = false;
      this.initData();
    },
    initData: function initData() {
      this.ruleForm.type = 0;
      this.ruleForm.region = 0;
      this.scanToken = '';
      this.webImgUrl = '';
      this.ruleForm.imgList = [];
      clearInterval(this.time);
      this.time = undefined;
    }
  }
};